var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons8Mailbox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 61,
    opacity: 0.3,
    rx: 19,
    ry: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#008aa9",
    d: "M53,51H16.584l0.101-37H47c5.523,0,10,4.477,10,10v23C57,49.209,55.209,51,53,51z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4ccff1",
    d: "M23,51H11c-2.209,0-4-1.791-4-4V24c0-5.523,4.477-10,10-10l0,0c5.523,0,10,4.477,10,10v23 C27,49.209,25.209,51,23,51z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fd3c4f",
    d: "M49.984,30.998l0.014-8c0.002-1.105-0.891-2.002-1.996-2.004l-12-0.022 c-1.105-0.002-2.002,0.891-2.004,1.996l0,0c-0.002,1.105,0.891,2.002,1.996,2.004l5,0.009l-0.011,6 c-0.002,1.105,0.891,2.002,1.996,2.004l5,0.009C49.086,32.996,49.982,32.103,49.984,30.998z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#008aa9",
    d: "M22,29H12c-1.105,0-2-0.895-2-2l0,0c0-1.105,0.895-2,2-2h10c1.105,0,2,0.895,2,2l0,0 C24,28.105,23.105,29,22,29z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.685,14.016C11.309,14.184,7,18.583,7,24v9c2.761,0,5-2.238,5-5v-4 c0-2.712,2.127-4.902,4.842-4.986c0.08-0.003,0.16-0.008,0.239-0.014H20c2.761,0,5-2.238,5-5h-8.315L16.685,14.016z",
    opacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57,47V31c-2.761,0-5,2.238-5,5v9c0,0.552-0.448,1-1,1h-5c-2.761,0-5,2.238-5,5h12 C55.209,51,57,49.209,57,47z",
    opacity: 0.15
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M10.987,21.514c0.314-0.765,0.77-1.455,1.337-2.039s1.243-1.06,1.998-1.398"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Mailbox);
export default __webpack_public_path__ + "static/media/icons8-mailbox.4c642e0ab2c09f2f6245d4100c3da73c.svg";
export { ForwardRef as ReactComponent };